import React from 'react';
import { BilingualText } from '../components/BilingualText';
import { ArrowLeft, BarChart3, TrendingUp, Users, Package, Calendar, Download, Filter, ChevronDown, ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line, PieChart, Pie, Cell } from 'recharts';
import { Link, useNavigate } from 'react-router-dom';
const shipmentData = [{
  name: 'Mon',
  shipments: 40,
  capacity: 50
}, {
  name: 'Tue',
  shipments: 35,
  capacity: 50
}, {
  name: 'Wed',
  shipments: 48,
  capacity: 50
}, {
  name: 'Thu',
  shipments: 42,
  capacity: 50
}, {
  name: 'Fri',
  shipments: 30,
  capacity: 50
}, {
  name: 'Sat',
  shipments: 15,
  capacity: 20
}, {
  name: 'Sun',
  shipments: 10,
  capacity: 20
}];
const statusData = [{
  name: 'Completed',
  value: 400,
  color: '#22c55e'
}, {
  name: 'Pending',
  value: 120,
  color: '#eab308'
}, {
  name: 'Cancelled',
  value: 45,
  color: '#ef4444'
}, {
  name: 'In Progress',
  value: 85,
  color: '#3b82f6'
}];
export function Reports() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-906">
      <header className="bg-white px-4 py-6 border-b border-slate-200 flex items-center justify-between sticky top-0 z-10 lg:px-8" data-id="element-907">
        <div className="flex items-center gap-4" data-id="element-908">
          <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-slate-600 hover:bg-slate-50 rounded-full transition-colors" data-id="element-909">
            <ArrowLeft size={24} data-id="element-910" />
          </button>
          <BilingualText en="Analytics & Reports" ar="التحليلات والتقارير" className="text-xl font-bold" data-id="element-911" />
        </div>
        <div className="flex gap-2" data-id="element-912">
          <button className="btn-secondary py-2 px-4 text-sm" data-id="element-913">
            <Filter size={18} data-id="element-914" />
            <span data-id="element-915">Filters</span>
          </button>
          <button className="btn-primary py-2 px-4 text-sm" data-id="element-916">
            <Download size={18} data-id="element-917" />
            <span data-id="element-918">Export</span>
          </button>
        </div>
      </header>

      <main className="p-4 md:p-8 max-w-7xl mx-auto space-y-8" data-id="element-919">
        {/* KPI Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-920">
          <KpiCard title="Total Shipments" value="1,284" change="+12.5%" isUp={true} icon={Package} color="text-blue-600" bgColor="bg-blue-50" data-id="element-921" />
          <KpiCard title="Avg. Unload Time" value="42 min" change="-4.2%" isUp={false} icon={TrendingUp} color="text-green-600" bgColor="bg-green-50" data-id="element-922" />
          <KpiCard title="Active Suppliers" value="84" change="+2" isUp={true} icon={Users} color="text-purple-600" bgColor="bg-purple-50" data-id="element-923" />
          <KpiCard title="Capacity Utilization" value="88.4%" change="+5.1%" isUp={true} icon={BarChart3} color="text-orange-600" bgColor="bg-orange-50" data-id="element-924" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-925">
          {/* Weekly Volume Chart */}
          <div className="card p-6 space-y-6" data-id="element-926">
            <div className="flex items-center justify-between" data-id="element-927">
              <BilingualText en="Weekly Shipment Volume" ar="حجم الشحنات الأسبوعي" className="text-lg" data-id="element-928" />
              <div className="flex items-center gap-2 text-xs text-slate-400" data-id="element-929">
                <div className="flex items-center gap-1" data-id="element-930">
                  <div className="w-3 h-3 rounded-sm bg-[#2E3192]" data-id="element-931" />
                  <span data-id="element-932">Actual</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-933">
                  <div className="w-3 h-3 rounded-sm bg-slate-200" data-id="element-934" />
                  <span data-id="element-935">Capacity</span>
                </div>
              </div>
            </div>
            <div className="h-80 w-full" data-id="element-936">
              <ResponsiveContainer width="100%" height="100%" data-id="element-937">
                <BarChart data={shipmentData} data-id="element-938">
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" data-id="element-939" />
                  <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                  fill: '#94a3b8',
                  fontSize: 12
                }} dy={10} data-id="element-940" />
                  <YAxis axisLine={false} tickLine={false} tick={{
                  fill: '#94a3b8',
                  fontSize: 12
                }} data-id="element-941" />
                  <Tooltip contentStyle={{
                  borderRadius: '12px',
                  border: 'none',
                  boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1)'
                }} cursor={{
                  fill: '#f8fafc'
                }} data-id="element-942" />
                  <Bar dataKey="shipments" fill="#2E3192" radius={[4, 4, 0, 0]} barSize={32} data-id="element-943" />
                  <Bar dataKey="capacity" fill="#e2e8f0" radius={[4, 4, 0, 0]} barSize={32} data-id="element-944" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Status Distribution */}
          <div className="card p-6 space-y-6" data-id="element-945">
            <BilingualText en="Shipment Status Distribution" ar="توزيع حالة الشحنات" className="text-lg" data-id="element-946" />
            <div className="flex flex-col md:flex-row items-center justify-center gap-8" data-id="element-947">
              <div className="h-64 w-64" data-id="element-948">
                <ResponsiveContainer width="100%" height="100%" data-id="element-949">
                  <PieChart data-id="element-950">
                    <Pie data={statusData} cx="50%" cy="50%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value" data-id="element-951">
                      {statusData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-952" />)}
                    </Pie>
                    <Tooltip data-id="element-953" />
                  </PieChart>
                </ResponsiveContainer>
              </div>
              <div className="space-y-3 flex-1 w-full" data-id="element-954">
                {statusData.map(item => <div key={item.name} className="flex items-center justify-between p-3 bg-slate-50 rounded-xl" data-id="element-955">
                    <div className="flex items-center gap-3" data-id="element-956">
                      <div className="w-3 h-3 rounded-full" style={{
                    backgroundColor: item.color
                  }} data-id="element-957" />
                      <span className="text-sm font-medium text-slate-600" data-id="element-958">
                        {item.name}
                      </span>
                    </div>
                    <span className="text-sm font-bold" data-id="element-959">{item.value}</span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>

        {/* Top Suppliers Table */}
        <div className="card overflow-hidden" data-id="element-960">
          <div className="p-6 border-b border-slate-100 flex items-center justify-between" data-id="element-961">
            <BilingualText en="Top Suppliers by Volume" ar="كبار الموردين حسب الحجم" className="text-lg" data-id="element-962" />
            <button className="text-[#2E3192] text-sm font-bold flex items-center gap-1" data-id="element-963">
              <span data-id="element-964">View All</span>
              <ChevronDown size={16} data-id="element-965" />
            </button>
          </div>
          <div className="overflow-x-auto" data-id="element-966">
            <table className="w-full text-left" data-id="element-967">
              <thead className="bg-slate-50 text-slate-400 text-xs uppercase tracking-wider" data-id="element-968">
                <tr data-id="element-969">
                  <th className="px-6 py-4 font-bold" data-id="element-970">Supplier</th>
                  <th className="px-6 py-4 font-bold" data-id="element-971">Shipments</th>
                  <th className="px-6 py-4 font-bold" data-id="element-972">Units</th>
                  <th className="px-6 py-4 font-bold" data-id="element-973">On-Time %</th>
                  <th className="px-6 py-4 font-bold text-right" data-id="element-974">Trend</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-975">
                <SupplierRow name="Global Logistics" shipments={142} units="5,840" onTime="98.2%" trend="up" data-id="element-976" />
                <SupplierRow name="FastTrack Trading" shipments={98} units="3,120" onTime="94.5%" trend="up" data-id="element-977" />
                <SupplierRow name="Prime Goods Ltd" shipments={84} units="4,500" onTime="89.0%" trend="down" data-id="element-978" />
                <SupplierRow name="Al-Futtaim Group" shipments={76} units="2,800" onTime="96.8%" trend="up" data-id="element-979" />
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>;
}
function KpiCard({
  title,
  value,
  change,
  isUp,
  icon: Icon,
  color,
  bgColor
}: any) {
  return <div className="card p-5 space-y-4" data-id="element-980">
      <div className="flex items-center justify-between" data-id="element-981">
        <div className={`p-2 rounded-lg ${bgColor} ${color}`} data-id="element-982">
          <Icon size={20} data-id="element-983" />
        </div>
        <div className={`flex items-center gap-1 text-xs font-bold ${isUp ? 'text-green-600' : 'text-red-600'}`} data-id="element-984">
          {isUp ? <ArrowUpRight size={14} data-id="element-985" /> : <ArrowDownRight size={14} data-id="element-986" />}
          <span data-id="element-987">{change}</span>
        </div>
      </div>
      <div data-id="element-988">
        <div className="text-slate-400 text-sm font-medium" data-id="element-989">{title}</div>
        <div className="text-2xl font-bold text-slate-800" data-id="element-990">{value}</div>
      </div>
    </div>;
}
function SupplierRow({
  name,
  shipments,
  units,
  onTime,
  trend
}: any) {
  return <tr className="hover:bg-slate-50 transition-colors" data-id="element-991">
      <td className="px-6 py-4 font-bold text-slate-700" data-id="element-992">{name}</td>
      <td className="px-6 py-4 text-slate-600" data-id="element-993">{shipments}</td>
      <td className="px-6 py-4 text-slate-600" data-id="element-994">{units}</td>
      <td className="px-6 py-4" data-id="element-995">
        <span className={`font-bold ${parseFloat(onTime) > 95 ? 'text-green-600' : 'text-yellow-600'}`} data-id="element-996">
          {onTime}
        </span>
      </td>
      <td className="px-6 py-4 text-right" data-id="element-997">
        {trend === 'up' ? <ArrowUpRight className="inline text-green-500" size={18} data-id="element-998" /> : <ArrowDownRight className="inline text-red-500" size={18} data-id="element-999" />}
      </td>
    </tr>;
}